import { Component, Vue } from "vue-property-decorator";
import VueStore from "@/store/VueStore";

import { Auth } from "aws-amplify";
import { SignUpParams } from "@aws-amplify/auth/lib/types/Auth";
import {
  ISignUpResult,
} from "amazon-cognito-identity-js";
import { ValidationChecker } from "./lib/validation";
import router from "@/router";
import { i18n } from "@/main";

@Component({
  name: "signUp",
  created() {
    localStorage.clear();
    this.$parent.$children[0].$data.headerElement = false;
  },
})
export default class SignUp extends Vue {
  public inputArea: boolean = true;
  public confirmMessage: boolean = false;
  public confirmMessageText: string = "";
  public resentMessage: boolean = false;
  public idInputArea: boolean = true;
  public email: string = "";
  public user: string = "";
  public password: string = "";
  public error: string = "";
  public signUpButton: boolean = true;
  public signUpLoadButton: boolean = false;
  public agreeTerms: boolean = false;

  public setMailAddress() {
    this.idInputArea = !this.idInputArea;
    if (this.idInputArea) {
      this.user = "";
    } else {
      this.user = this.email;
    }
  }

  public signUp() {
    this.signUpButton = false;
    this.signUpLoadButton = true;

    if (!ValidationChecker.checkAllValidation(this)) {
      this.signUpButton = true;
      this.signUpLoadButton = false;
      return;
    }

    const self = this;
    const params: SignUpParams = {
      username: this.user,
      password: this.password,
      attributes: {
        "email": this.email,
        "custom:graphSettings": JSON.stringify({
          useSignal: false,
          useTimeZone: "+09:00",
          graphIDs: [],
        }),
      },
      validationData: [],
    };
    Auth.signUp(params).then((user: ISignUpResult) => {
      VueStore.commit("setUser", this.user);
      this.inputArea = false;
      // 変数入りのメッセージが文法上おかしくないようif分岐
      if (i18n.locale === "ja") {
        this.confirmMessageText = this.email + this.$t("message.validationEmailSentTo");
      } else {
        this.confirmMessageText = this.$t("message.validationEmailSentTo") + this.email;
      }
      this.confirmMessage = true;
    }).catch((err: any) => {
      console.error(err);
      self.checkSignUpError(err.code);
      this.signUpButton = true;
      this.signUpLoadButton = false;
    });
  }

  public checkSignUpError(code: string) {
    const self = this;
    switch (code) {
      case "UsernameExistsException":
        self.error = this.$t("message.thisIdAlreadyExists") as string;
        return;
      default:
        self.error = this.$t("message.failedToRegister") as string;
        return;
    }
  }

  public resentMail() {
    const userName = VueStore.state.userName;
    Auth.resendSignUp(userName).then(() => {
      this.resentMessage = true;
    }).catch((err: any) => {
      console.error(err);
    });
  }

  public backLoginPage() {
    return router.push("/signIn");
  }
}
